import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const Container = styled.div`
  width: 100%;
  max-width: ${theme.distances.containerMaxWidth};
  margin-left: auto;
  margin-right: auto;
  padding-left: ${theme.distances.containerGutter};
  padding-right: ${theme.distances.containerGutter};

  &.p-y-md {
    padding-top: ${size(4)};
    padding-bottom: ${size(4)};
  }

  ${theme.screens.Md} {
    &:not(.in-panel) {
      padding-left: ${theme.distances.containerGutterMd};
      padding-right: ${theme.distances.containerGutterMd};

      &.limit-width {
        max-width: ${theme.distances.contentMaxWidth};
        margin-left: auto;
        margin-right: auto;
      }
    }
    &.in-panel {
      padding-left: ${size(3)};
      padding-right: ${size(3)};
    }
  }
`;
